export default __webpack_public_path__ + "static/media/fnublado.4738a53d.svg";